import { Product, ProductFamily } from './pdf-layout';
import { familyLogoWrapperStyle, logoStyle } from './product-row.styles';
import { productFamilyNameText } from './pdf-layout.styles';
import { PricingPeriod } from '@atlassiansox/bxp-use-pricing';

type ProductRowProps = {
  product: Product;
  shouldDisplayFamilyRow?: boolean;
  family: ProductFamily;
  billingCycle: PricingPeriod;
};

const ProductRow = ({
  product,
  shouldDisplayFamilyRow,
  family,
  billingCycle
}: ProductRowProps) => {
  let userTypelabel;

  if (product.name === 'Jira Service Management') {
    userTypelabel = 'agents';
  } else if (product.name === 'Jira Product Discovery') {
    userTypelabel = 'creators';
  } else {
    userTypelabel = 'users';
  }

  return (
    <div className="pdf-row" data-testid="product-row">
      <div className="col col1">
        {!shouldDisplayFamilyRow ? (
          <div css={familyLogoWrapperStyle}>{family.logo}</div>
        ) : (
          <div css={logoStyle}>{product.logo}</div>
        )}
        {!shouldDisplayFamilyRow ? (
          <div css={productFamilyNameText}>{product.name}</div>
        ) : (
          <div>{product.name}</div>
        )}
      </div>
      <div className="col col2">{product.selectedPlanName || ''}</div>
      <div className="col col3">
        {product.selectedUserCount} {userTypelabel}
      </div>
      {billingCycle == 'ANNUAL' ? (
        <div className="col col4">{product.userTypeTier}</div>
      ) : (
        <div className="col col4">{product.costPerUserType}</div>
      )}
      <div className="col col5">{product.monthlyCost}</div>
    </div>
  );
};

export default ProductRow;
